import { Button, Input, message, Space } from 'antd'
import { useToken } from 'app/hooks'
import { set } from 'lodash'
import React from 'react'
import { View } from 'styles/reactnative'
import useSWR from 'swr'
import API from 'utils/api'

const SSlipage = ({ ep_id }) => {
	const { data: token } = useToken()

	const [force, setForce] = React.useState<any>(0)
	const [max, setMax] = React.useState<any>(1000)

	const { data } = useSWR(`/admin/slip/sslip?ep_id=*`, async url => {
		const res = await API.get(url, token + '', {}, false).then(
			res => res?.result
		)
		return res || []
	})

	React.useEffect(() => {
		if (data?.result) {
			const find = data?.result?.find(i => i.ep_id == ep_id)?.value
			if (find) {
				const split = find.split(':')
				setForce(split[0])
				setMax(split[1])
			}
		}
	}, [data])

	return (
		<Space style={{ width: '100%', padding:0, gap:0, fontSize:11 }} size={'small'} direction="horizontal">
			강제
			<Input
				value={force}
				onChange={e => setForce(e.target.value)}
				type="number"
				max={1000}
				min={0}
				style={{ width: 60, fontSize: 10, background: force> 0 ? '#f1eeee' : '#ffffff' }}
			/>{' '}
			최대
			<Input
				value={max}
				onChange={e => setMax(e.target.value)}
				type="number"
				max={1000}
				min={0}
				style={{ width: 60, fontSize: 10 , background: max> 1000 ? '#f1eeee' : '#ffffff' }}
			/>
			<Button
				onClick={() => {
					API.post(`/admin/slip/sslip`, token + '', {
						ep_id,
						force,
						max,
					}).then(res => {
						message.success('적용되었습니다.')
					})
				}}
				size="small">
				반영
			</Button>
		</Space>
	)
}

export default React.memo(SSlipage)
